import { Injectable } from "@angular/core";
import { ExcelHelperService } from "../addin-helper-services/excel-helper.service";
import {
  EXCEL_PROTECTION_PASSWORD,
  WORKPAPER_CONTEXT_SETTINGS,
} from "../../constants/workbook.constants";
import { ApplicationContext } from "../../model";
import { BehaviorSubject, firstValueFrom } from "rxjs";
import { SecretService } from "../crypto/secrets.service";
import { MsalService } from "@azure/msal-angular";
import { Profile } from "typings";
import { UserGlobalContext } from "src/app/model/user-global-context.model";
import { UserRolesAndPermissionsResponseDto } from "src/app/model/common/user-roles-permissions-response.model";
import { RolesResponseDto } from "src/app/model/common/roles-response.model";
import { UserContextPermissionRoleService } from "../user/user-context-permission-role.service";

@Injectable({
  providedIn: `root`,
})
export class GlobalStateService {
  private appContext!: ApplicationContext;
  private _userContext$ = new BehaviorSubject<UserGlobalContext | null>(null);
  constructor(
    private excelHelper: ExcelHelperService,
  ) {}

  // Retrieves the current workpaper context data.
  getWorkpaperContextData(): ApplicationContext {
    return this.appContext;
  }

  // Returns true when the loaded workpaper belongs to a Reporting Group client.
  isRGWorkpaper(): boolean {
    return !!this.appContext?.reportingGroupId;
  }

  // Sets the workpaper context data by reading from the Excel sheet.
  async setWorkpaperContextData(): Promise<void> {
    const sheetName = WORKPAPER_CONTEXT_SETTINGS.ClientEntityPeriodFromSheet;
    const cellAddress =
      WORKPAPER_CONTEXT_SETTINGS.ClientEntityPeriodFromCellAddress;

    const adminSheetExists = await this.excelHelper.getSheetByName(sheetName);
    if (!adminSheetExists) {
      console.warn(`${sheetName} Sheet not found.`);
      return;
    }

    const values = await this.excelHelper.readCellValues(
      sheetName,
      cellAddress
    );
    const [clientId, entityId, clientTaxPeriodId, vertexCompanyCode, reportingGroupId] =
      values[0];

    this.appContext = {
      clientId: clientId?.trim().toLowerCase() ?? '',
      entityId: entityId?.trim().toLowerCase() ?? '',
      clientTaxPeriodId,
      vertexCompanyCode,
      reportingGroupId: reportingGroupId?.toString()?.trim() || undefined,
    };

    // TODO:v Setting password is throwing unhandled exception. Need to investigate.
    // this.setPassword();
  }
}
